import React from "react";
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row
} from "reactstrap";

import SelectListComponent from "../utils/selectList";
import DateSelector from "../utils/dateSelector";
import { appConstants } from "../../_constants";

const InvoiceSearchPanel = ({
  pageMode,
  filters,
  selectedFilterMode,
  filterOptions,
  filterValues,
  filterLabelKey,
  filterValueKey,
  onFilterModeValueChange,
  onSelectedFilterValuesChange,
  processDateChange,
  onSearch
}) => {
  return (
    <Form onSubmit={e => e.preventDefault()}>
      <Container>
        <Row>
          {pageMode === appConstants.INVOICE_RECONCILIATION_SEARCH_MODE && (
            <Col xs="6" sm="3">
              <FormGroup className="mb-4">
                <Label>Process Date</Label>
                <DateSelector
                  maxDate={new Date()}
                  name="processDate"
                  onValueChange={processDateChange}
                />
              </FormGroup>
            </Col>
          )}
          <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>Filter Mode</Label>
              <SelectListComponent
                data={filters}
                valueKey="id"
                textField="name"
                selectValue={selectedFilterMode}
                onValueChange={onFilterModeValueChange}
                clearable={false}
              />
            </FormGroup>
          </Col>
          <Col xs="6" sm="5">
            <FormGroup className="mb-4">
              <Label>Search Box</Label>
              <SelectListComponent
                data={filterOptions}
                multiSelectMode={true}
                selectValue={filterValues}
                valueKey={filterLabelKey}
                textField={filterValueKey}
                onValueChange={onSelectedFilterValuesChange}
              />
            </FormGroup>
          </Col>
          <Col xs="6" sm="1">
            <label>&nbsp;</label>
            <Button className="btn-avi-primary" onClick={() => onSearch()}>
              Search
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};
export default InvoiceSearchPanel;



// WEBPACK FOOTER //
// ./src/views/invoice/invoice-search-panel.js